<template>
    <vxe-modal
        v-model="formInput.isShow"
        title="修改数字员工信息"
        width="840"
        height="600"
        show-zoom
        resize
        remember
        show-footer
        :z-index="10000"
        :transfer="true"
    >
        <template #default>
            <vxe-form
                :data="formInput.formData"
                title-align="right"
                ref="rFormTableau"
                height="100%"
                title-width="60"
            >
                <vxe-form-item
                    title="基本信息"
                    span="24"
                    title-align="left"
                    title-width="200px"
                    :title-prefix="{ icon: 'fa fa-address-card-o' }"
                ></vxe-form-item>
                <vxe-form-item
                    title="流程ID"
                    field="ProcessID"
                    span="12"
                    title-width="100px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.ProcessID"
                            readonly
                            disabled
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="流程名称"
                    field="ProcessName"
                    span="12"
                    title-width="100px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.ProcessName"
                            disabled
                            readonly
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="排序"
                    field="seq"
                    span="12"
                    title-width="100px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.seq"
                            type="number"
                            placeholder="请输入序号"
                            clearable
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="是否首页隐藏"
                    field="IsHidden"
                    span="12"
                    title-width="100px"
                >
                    <template #default>
                        <vxe-select
                            :options="[
                                { value: '0', label: '否' },
                                { value: '1', label: '是' },
                            ]"
                            v-model="formInput.formData.IsHidden"
                        ></vxe-select>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="数字员工头像"
                    span="24"
                    title-align="left"
                    title-width="200px"
                    :title-prefix="{ icon: 'fa fa-user-circle' }"
                ></vxe-form-item>
                <vxe-form-item title="" align="center" span="24">
                    <template #default>
                        <div class="avatar-card">
                            <div class="avatar-preview">
                                <img
                                    v-if="formInput.formData.photo === ''"
                                    src="@/static/images/emp.png"
                                    alt="avatar"
                                />
                                <img
                                    v-else
                                    :src="formInput.formData.photo"
                                    alt="avatar"
                                />
                            </div>

                            <div class="avatar-actions">
                                <vxe-button @click="setDefaultPhoto"
                                    >默认头像</vxe-button
                                >

                                <vxe-button
                                    status="primary"
                                    @click="insertEvent(false)"
                                >
                                    选择文件
                                </vxe-button>

                                <span class="photo-tip">
                                    支持 jpg / jpeg / png / gif 格式图片
                                </span>
                            </div>
                        </div>
                    </template>
                </vxe-form-item>
            </vxe-form>
        </template>
        <template #footer>
            <div style="text-align: center; width: 100%">
                <vxe-button
                    :loading="submitting"
                    @click="save"
                    icon="fa fa-save"
                    status="success"
                    >保存
                </vxe-button>
                <vxe-button
                    @click="
                        () => {
                            formInput.isShow = false;
                        }
                    "
                    icon="fa fa-close"
                    status="normal"
                    >关闭
                </vxe-button>
            </div>
        </template>
    </vxe-modal>
</template>
<script setup>
import {
    reactive,
    ref,
    onMounted,
    onUnmounted,
    watch,
    getCurrentInstance,
    defineExpose,
    defineEmits,
} from "vue";

import { VXETable } from "vxe-table";
import Qs from "qs";
const { proxy } = getCurrentInstance();
const submitting = ref(false);
const emit = defineEmits(["flashData"]);
const formInput = reactive({
    isShow: false,
    formData: {
        Id: "",
        ProcessID: "",
        ProcessName: "",
        IsHidden: "0",
        photo: "",
        seq: 0,
    },
});

const showSetting = (row) => {
    console.log("showSetting", row);
    formInput.isShow = true;
    formInput.formData.photo = row.photo;
    formInput.formData.Id = row.Id;
    formInput.formData.ProcessID = row.ProcessID;
    formInput.formData.ProcessName = row.ProcessName;
    formInput.formData.IsHidden = row.IsHidden;
    formInput.formData.seq = row.seq;
};
const setDefaultPhoto = () => {
    formInput.formData.photo = "";
};
let oneFileName = "";
let oneFile = null;
//选择文件上传
const insertEvent = async () => {
    const { files } = await VXETable.readFile(false);

    Array.from(files).map((file) => {
        oneFileName = file.name;
        oneFile = file;
        updatePortrait(file); //fix
        console.log(file);
    });
};
//上传头像
const updatePortrait = (fileParam) => {
    const fData = new FormData();

    fData.append("id", formInput.formData.Id); //0 传0或不传
    fData.append("fileName", formInput.formData.photo); //0 传0或不传
    fData.append("file", fileParam); //版块ID
    proxy.$api.jobManageAPI
        .updateRobotPhoto(fData)
        .then((res) => {
            if (res.data.Success === false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            formInput.formData.photo = res.data.Data;
            console.log(res);
            VXETable.modal.message({
                content: "上传头像成功",
                status: "success",
            });
        })
        .catch((error) => {
            console.log(error);
        });
};
const save = async () => {
    const params = formInput.formData;

    proxy.$api.jobManageAPI
        .saveRobotAlias(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success === false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            VXETable.modal.message({
                content: "保存成功",
                status: "success",
            });

            formInput.isShow = false;
            emit("flashData");
        })
        .catch((error) => {
            VXETable.modal.message({ content: error, status: "error" });
            console.log(error);
        });
};
defineExpose({ showSetting });
</script>
<style scoped>
.avatar-card {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    padding: 12px 16px;
    border-radius: 12px;
    background: #fafafa;
    border: 1px solid #e5e7eb;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.04);
}

.avatar-preview {
    width: 160px;
    height: 160px;
    border-radius: 12px;
    overflow: hidden;
    border: 0px solid #e5e7eb;
    /* background: #fff; */
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
}

.avatar-preview img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.avatar-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    justify-content: center;
}

.photo-tip {
    color: #909399;
    font-size: 12px;
}
</style>
